import {
      HomeOgImage,
      DevopsConsultingServicesOgImage,
      DigitalTransformationOgImage,
      HireDedicatedMobileWebDevelopersOgImage,
      InternetOfThingsIotApplicationsOgImage,
      MobileApplicationDevelopmentOgImage,
      MvpDevelopmentCompanyOgImage,
      ProductEngineeringServicesOgImage,
      SaasDevelopmentCompanyOgImage,
      SoftwareDevelopmentCompanyOgImage,
      WebApplicationDevelopmentOgImage,
      PortugalStrategicPartnershipImage,
      FinancialSoftwareDevelopmentOgImage,
      HealthcareSoftwareDevelopmentOgImage,
      LogisticsSoftwareDevelopmentOgImage,
      DjangoDevelopmentOgImage,
      LaravelDevelopmentOgImage,
      MeanStackDevelopmentOgImage,
      MernStackDevelopmentOgImage,
      // PatientRegistrySoftwareDevelopmentOgImage,
      // TelemedicineAppDevelopmentOgImage,
      // HealthcareIotSolutionsOgImage,
      // MobilebankingOgImage,
      // MhealthappOgImage,
      // CrossBorderRemittanceSoftwareDevelopmentOgImage,
      // EwalletappdevelopmentOgImage,
      // MerchantPaymentServicesOgImage,
      RemotePatientMonitoringSolutionsOgImage,
      PatientEngagementSoftwareDevelopmentOgImage,
      SocialDefaultImage
} from "../utils/imageConst";

export const HomeMeta = {
      metaTitle: `Software Development Company-Peerbits`,
      metaDescription: "Peerbits, a leading software development company in India, offers custom software solutions and offshore development teams with deep industry expertise.",
      ogTitle: "",
      ogDescription: "",
      ogType: "website",
      ogSiteName: "",
      ogImage: HomeOgImage,
      twitterCard: "",
      twitterCreator: "",
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: HomeOgImage
};

export const PortfolioMeta = {
      metaTitle: `Helped 500+ Global Companies Transform Their Business`,
      metaDescription: "We empowered 500+ global companies to revolutionize their business. Discover our outstanding work & outcomes we delivered. Trust us for digital transformation.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PortfolioCateroyMeta = {
      metaTitle: `Project Portfolio - Peerbits`,
      metaDescription: "With 14+ years of experience, Peerbtis is on a mission to build digital products our clients envisioned and enhance their potential.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogMeta = {
      metaTitle: `Insightful blogs | Peerbits`,
      metaDescription: "Stay updated with the latest news and trends in mobile app & software development, IoT, Blockchain, and most latest technologies via our well-researched blogs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogCateroyMeta = {
      metaTitle: `Blogs by Peerbits`,
      metaDescription: "Explore Peerbits’ well-researched blogs and articles to access the latest trends, tips, news, updates, and expert insights.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogAuthorMeta = {
      metaTitle: `Blogs by Peerbits`,
      metaDescription: "We have built web, apps, Mobile apps, enterprise software, and more. See the success stories of our global clients from across the industries.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ResourcesMeta = {
      metaTitle: `Meet the Expert Tech Resources - Peerbits`,
      metaDescription: "Expert our technology experts to build digital solution tailored to your business needs. Meet our team of experienced developers and bring your ideas to life.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ContactUsMeta = {
      metaTitle: `Fill Up the Form & Tell Us Your Requirements - Peerbits`,
      metaDescription: "You can request a quote anytime by filling up the form round the clock, or meet us by personally visiting in the office hours.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireReactjsDevelopersMeta = {
      metaTitle: `Hire Dedicated ReactJS Developers | Hire ReactJS Experts`,
      metaDescription: "Hire dedicated Reactjs developers to build high-performing Android & iOS web apps under a flexible hiring model. Get offshore React developers for your business now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HirePythonDevelopersMeta = {
      metaTitle: `Hire Dedicated Python Developers | Hire Python Experts`,
      metaDescription: "Hire dedicated Python developers for your next project who will work as an extension to your in-house team. Hire only to get high-quality solutions on time.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireNodejsDevelopersMeta = {
      metaTitle: `Hire Dedicated NodeJS Developers | Hire NodeJS Experts`,
      metaDescription: "Hire top Node.js developers from Peerbits for on-time & budget-friendly development services with 14-days risk-free trial. Hire node.js developers now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireSymfonyFrameworkDevelopersMeta = {
      metaTitle: `Hire Dedicated Symfony Developers | Hire Symfony Experts`,
      metaDescription: "Peerbits is a leading Symfony development company that offers expert symfony developers for hire to start-ups and enterprises at affordable rate. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireDjangoDeveloperMeta = {
      metaTitle: `Hire Dedicated Django Developers | Hire Django Experts`,
      metaDescription: "Hire dedicated Django developers from Peerbits at 14 day risk free trial. Get top-rated Django development services at the lowest possible cost.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const HireLaravelDeveloperMeta = {
      metaTitle: `Hire Dedicated Laravel Developers | Hire Laravel Experts`,
      metaDescription: "Hire best laravel developers from Peerbits at your convenient engagement model. Leverage their skillset to create lightning-fast APIs for mobile and web apps.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireMeanStackDeveloperMeta = {
      metaTitle: `Hire Dedicated MEAN Stack Developers | Hire MEAN Experts`,
      metaDescription: "Hire dedicated MEAN stack developers from Peerbits & get access to India's top 1% top talent. Get top-notch MEAN stack development services at the lowest cost.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireMernStackDeveloperMeta = {
      metaTitle: `Hire Dedicated MERN Stack Developers | Hire MERN Experts`,
      metaDescription: "Hire MERN Stack developers from Peerbits at 14 day risk free trial who can efficiently work with all open-source components of MERN. Hire at your choice.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const processMeta = {
      metaTitle: `Agile Software Development Process - Peerbits`,
      metaDescription: "Peerbits follow custom robust software development process to deliver high quality solutions on timely manner. We follow agile development methods.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurStoryMeta = {
      metaTitle: `Peerbits Story - A Journey of Success in Tech World`,
      metaDescription: "Discover the story of Peerbits - A software development company. Learn how we help businesses innovate and grow with cutting-edge tech solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const EngagementModelMeta = {
      metaTitle: `Engagement Models|Offshore Development Services-Peerbits`,
      metaDescription: "Achieve project goals seamlessly with our staff augmentation, dedicated teams and software development outsourcing services. Partner with Peerbits now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LifeAtPeerbitsMeta = {
      metaTitle: `Life at Peerbits is full of opportunities, learning`,
      metaDescription: "Join Peerbits to skyrocket your career with excellent growth opportunities in a dynamic environment which promotes excellence, innovation, and growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CareersMeta = {
      metaTitle: `Careers | Jobs | Careers@Peerbits | Jobs@Peerbits`,
      metaDescription: "Build a career working with Peerbits brighten your future. Apply for job openings by emailing your updated resume or CV to career@peerbits.com.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TestimonialsMeta = {
      metaTitle: `Reviews and Testimonials from Our Global Clients - Peerbits`,
      metaDescription: "Reviews & Testimonials from Global Clients at Peerbits. See what our satisfied customers have to say about our services. Visit us now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MobileApplicationDevelopmentMeta = {
      metaTitle: `Mobile Application Development Company & Services`,
      metaDescription: "Peerbits is a leading mobile application development company, delivering full-cycle design and mobile app development services for iOS & Android at affordable rates.",
      ogImage: MobileApplicationDevelopmentOgImage,
      twitterImage: MobileApplicationDevelopmentOgImage
};

export const SoftwareDevelopmentCompanyMeta = {
      metaTitle: `Software Development Services - Peerbits`,
      metaDescription: "We offer high-quality custom software development services in India. Reduce business risk, cost & time to market with our skilled software development outsourcing.",
      ogImage: SoftwareDevelopmentCompanyOgImage,
      twitterImage: SoftwareDevelopmentCompanyOgImage
};


export const HireDedicatedMobileWebDevelopersTeamMeta = {
      metaTitle: `Hire Dedicated Indian Developers for USA | Peerbits`,
      metaDescription: "Hire dedicated Indian developers to meet your specific project needs. Get 180+ pre-vetted developers for USA, expert coders, and remote engineers for hire",
      ogImage: HireDedicatedMobileWebDevelopersOgImage,
      twitterImage: HireDedicatedMobileWebDevelopersOgImage
};
export const WebApplicationDevelopmentMeta = {
      metaTitle: `Web App Development Company & Services`,
      metaDescription: "Peerbits is a top web app development company, offering custom, modern, and affordable web app development services for your business growth.",
      ogImage: WebApplicationDevelopmentOgImage,
      twitterImage: WebApplicationDevelopmentOgImage
};

export const CloudOptimisationMeta = {
      metaTitle: `AWS Cloud Optimization Services | Peerbits`,
      metaDescription: "Maximize your enterprise efficiency & performance with our AWS Cloud Optimization Services. Save cost and time by optimizing your cloud resources for optimal usage.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TechnologyStackMeta = {
      metaTitle: `Peerbits Expertise in Leveraging Cutting-edge Technologies Solutions`,
      metaDescription: "Peerbits possess expertise in the best mobile app, frontend, backend, database, automated testing services along with other latest technology stack.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireMongodbDevelopersMeta = {
      metaTitle: `Hire Dedicated MongoDB Developers | Hire MongoDB Experts`,
      metaDescription: "Hire dedicated MongoDB developers from Peerbits who are highly skilled and experienced in developing top-notch solutions for your businesses across the world.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AmazonWebServicesPartnershipMeta = {
      metaTitle: `AWS Cloud Computing Services| AWS Cloud Services`,
      metaDescription: "Get experienced AWS cloud computing services for your evolving business needs. From planning to deployment, our cloud computing delivers solutions with precision.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwsConsultingServicesPageMeta = {
      metaTitle: `AWS Cloud Consulting Services | AWS Consulting Partner`,
      metaDescription: "Modernise your infrastructure with our AWS cloud consulting services. We are experts in planning & migrating enterprise cloud solutions to meet your demands.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ExtendDedicatedDevelopmentTeamMeta = {
      metaTitle: `Extend Your Offshore Software Development Team with Peerbtis`,
      metaDescription: "Extend your own dedicated software development team by leveraging our staff augmentation services that will upgrade your development capabilities by many folds.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ScheduleMeetingMeta = {
      metaTitle: `Schedule A Meeting: Schedule Your Personalized Session Today | Peerbits`,
      metaDescription: "Schedule a meeting to get personalized meeting to see our service in action and find out how it meets your needs. | Peerbits",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhyOffshoreMeta = {
      metaTitle: `Benefits of Choosing Offshore remote Development Center`,
      metaDescription: "Leverage the benefits of offshore remote development with Peerbits'. Extend your team, Improve efficiency, reduce costs, and access global talent, with ease.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhitepaperOnDemandApplication = {
      metaTitle: `Whitepaper: A Guide to On-demand Mobile App Development`,
      metaDescription: "Your roadmap to on-demand mobile app excellence awaits in our exclusive Whitepaper. Learn key techniques and principles for app development success.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperAutomotive = {
      metaTitle: `Whitepaper: Guide on Smart Vehicles, IoT, and Cloud Services`,
      metaDescription: "Learn about the intersection of smart vehicles, IoT, and cloud services in our comprehensive whitepaper. Explore the future of connected transportation.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperSmartHome = {
      metaTitle: `Whitepaper: Smart Home Solutions - IoT`,
      metaDescription: "Explore the future of Smart Home Solutions with our IoT Whitepaper. Explore cutting-edge technology and innovations in home automation. Download now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperSmartRetail = {
      metaTitle: `Whitepaper: Smart Retail Solutions`,
      metaDescription: "Discover innovative Smart Retail Solutions in our whitepaper. Explore cutting-edge technologies for enhancing retail efficiency. Download now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperLogistics = {
      metaTitle: `Whitepaper: A Complete Guide to IoT in Logistics - Peerbits`,
      metaDescription: "Learn all about the game-changing potential of IoT in logistics and stay ahead in the logistics industry through our detailed whitepaper.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ManagedItServicesMeta = {
      metaTitle: `Managed IT Services provider - App & Cloud Management`,
      metaDescription: "Peerbits is a leading managed IT services provider, offering infrastructure, cloud, application, and end-user management to boost your business efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ProductEngineeringServicesMeta = {
      metaTitle: `Product Engineering Services Company | Peerbits`,
      metaDescription: "Peerbits is a trusted product engineering company in India, USA. We deliver advanced custom solutions to empower your business, people, and future.",
      ogImage: ProductEngineeringServicesOgImage,
      twitterImage: ProductEngineeringServicesOgImage
};

export const FrontendDevelopmentMeta = {
      metaTitle: `Frontend Development Company India, USA - Peerbits`,
      metaDescription: "Hire front-end developers for expert design and development of your website or application. Skilled in HTML, CSS, JavaScript and user experience design.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MobileAppQualityAssuranceTestingServicesMeta = {
      metaTitle: `Automated Mobile Testing & Cross Platform Testing Services`,
      metaDescription: "Simplify mobile app testing and enhance its quality with our Automated & Cross Platform Testing Services. Stay ahead in the competitive digital landscape.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlockchainAppDevelopmentServicesMeta = {
      metaTitle: `Custom Blockchain App Development Services Company USA `,
      metaDescription: "Peerbits is a leading Blockchain App Development company USA. Offering various Custom Blockchain Development Services across industries to maximize productivity.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TopMobileAppDevelopmentCompanyUSAMeta = {
      metaTitle: `Top-Notch Mobile App Development Company USA - Peerbits`,
      metaDescription: "Get top mobile app development services in the USA from Peerbits - We specialize in iOS and Android development, consultation, and maintenance. Visit our service page.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const UiUxDesignMeta = {
      metaTitle: `Top Mobile App UI Design Company India, USA - Peerbits`,
      metaDescription: "Peerbits - a trusted UI/UX design company in India, USA. We offer a range of UI/UX design services like app and web design, landing page design and more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const GasDeliverySoftwareMeta = {
      metaTitle: `Gas Delivery Ordering Software, Best Gas Management Systems`,
      metaDescription: "Transform your gas delivery business with our cutting-edge gas management system. Reach a wider audience, improve efficiency, and boost your bottom line.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FuelDeliverySoftwareMeta = {
      metaTitle: `On-demand Fuel App Delivery Services, Company - Peerbits`,
      metaDescription: "Streamline fuel delivery operations with our cutting-edge fuel delivery software. Enhance efficiency & accuracy, boost productivity and reduce cost.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WarehouseManagementSoftwareMeta = {
      metaTitle: `Warehouse Management Software |  Inventory Management System`,
      metaDescription: "Get the latest RFID technology in warehouse management with Peerbits. Our smart WMS solution streamlines operations, saves cost, & improves efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OnDemandDeliveryAppDevelopmentMeta = {
      metaTitle: `On Demand Delivery Tracking App | On-Demand Dispatch Software`,
      metaDescription: "On Demand Delivery Software Solutions for courier, food delivery, field service and delivery companies to manage on demand dispatch system. Talk to expert now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OnDemandAppDevelopmentMeta = {
      metaTitle: `Top On Demand App Development company India, USA - Peerbits`,
      metaDescription: "Peerbits: A trusted on-demand app development company in India,USA. Get customized on-demand app development solutions for your holistic business growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const InternetOfThingsIotApplicationsMeta = {
      metaTitle: `IoT App Development Company USA, IoT development services`,
      metaDescription: "Peerbits - A leading IoT app development company specialized in developing innovative IoT apps. Transform your business with our IoT app development services.",
      ogImage: InternetOfThingsIotApplicationsOgImage,
      twitterImage: InternetOfThingsIotApplicationsOgImage
};

export const FullStackWebDevelopmentMeta = {
      metaTitle: `Best Full Stack Web Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a full stack web development company providing a wide range of services, including front-end & back-end development, to deliver your dream website.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ThankyouMeta = {
      metaTitle: `Thank You for Contacting Us - Peerbits`,
      metaDescription: "Thank you for your interest. Our team is grateful for your approach and we appreciate your trust in our brand. Stay connected with us for future updates.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RetailMobilitySolutionsMeta = {
      metaTitle: `Retail App Development Consulting & Solutions Company USA`,
      metaDescription: "Peerbits - A Leading retail app development company creating user-friendly and visually appealing mobile apps that provide a seamless shopping experience.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OilAndGasIndustryAppSolutionMeta = {
      metaTitle: `Oil & Gas Mobile App Development Solutions - Peerbits`,
      metaDescription: "Peerbits is a leading oil & gas industry app development services provider in India, USA. We use intelligent tools & tech to deliver efficient solutions. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WellnessAndFitnessAppDevelopmentMeta = {
      metaTitle: `Wellness & Fitness App Development Services Company - Peerbits`,
      metaDescription: "Peerbits - A trusted wellness & fitness app development company have years of experience in creating custom wellness apps with modern technology.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FinanceAppDevelopmentMeta = {
      metaTitle: `Finance App Development Company & Services- Peerbits`,
      metaDescription: "Build user-first financial apps with our end-to-end finance app development services based on your custom needs by the top finance app development company.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WearableAppDevelopmentMeta = {
      metaTitle: `Wearable App Development Solutions Company India, USA`,
      metaDescription: "Peerbits - A leading wearable app development company in India, USA. We develop top quality & bugfree wearable apps for iOS & Android at an affordable rate. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CrossPlatformApplicationFrameworksMeta = {
      metaTitle: `Cross Platform App Development Company USA - Peerbits`,
      metaDescription: "Peerbits provides Cross platform app development services for various industries, using variety of frameworks that allows apps to be native to iOS and Android.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SmartHomeAutomationSystemsMeta = {
      metaTitle: `IoT Smart Home Solutions | Home Automation System & Software`,
      metaDescription: "Redefine the way you live in your house with IoT home automation systems. Smart home solutions leverage the IoT technology to offer the comfort and convenience.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SmartEnergySolutionMeta = {
      metaTitle: `Custom IoT based Smart Energy Monitoring System Development`,
      metaDescription: "Get customized smart energy solutions for your business from Peerbits. Reduce costs and improve efficiency with our IoT-based systems.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LogisticsAppDevelopmentMeta = {
      metaTitle: `Logistics App Development Company & Services`,
      metaDescription: "A top logistics app development company in India, Peerbits builds custom logistics app solutions for the fleet industry. Get logistics development services today.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LastMileDeliveryLogisticsManagementSoftwareMeta = {
      metaTitle: `Last Mile Delivery Logistics Management Software - Peerbits`,
      metaDescription: "Enhance your supply chain operations, boost your company's reputation, and improve delivery management with our reliable last mile delivery software.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TransportationAppDevelopmentMeta = {
      metaTitle: `Transportation App Development Company | Mobility Solutions`,
      metaDescription: "Peerbits is a transportation app development company that provides cutting-edge mobility solutions to the transportation industry, delivering results of top quality.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HealthcareAppDevelopmentMeta = {
      metaTitle: `Healthcare App Development Services | mHealth Apps Solutions`,
      metaDescription: "Peerbits - A reliable healthcare app development company India, USA - creating mHealth solutions that meet the specific needs of healthcare organizations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ServicesMeta = {
      metaTitle: `Trusted Mobile App Development Services Company India, USA`,
      metaDescription: "Get top mobile app development services in USA from Peerbits. Our app design & development services include consultation, design, development, and maintenance.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TopAppDevelopmentCompanyMeta = {
      metaTitle: `Blockchain, IoT & Software App Development Company - Peerbits`,
      metaDescription: "Peerbits - A top-tier Blockchain, IoT, and Software App Development Company. delivering cutting-edge solutions worldwide. Get access to experts in no time. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};



export const MobileAppStrategyMeta = {
      metaTitle: `Best Mobile App Development Consulting Services - Peerbits`,
      metaDescription: "Get expert mobile app development strategies and consulting services from Peerbits. With our proven methods, we'll help you achieve your business goals.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const IphoneApplicationDevelopmentMeta = {
      metaTitle: `Top iPhone App Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a top iPhone app development company in India, USA - building exceptional iPhone apps using latest tech for various industries at affordable rates.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CaseStudiesMeta = {
      metaTitle: `Successful Mobile App Development and Design Case Studies`,
      metaDescription: "Read our top mobile app development and design case studies to discover how Peerbits help startups and enterprises to grow and expand businesses on Mobile.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};


export const LaravelDevelopmentMeta = {
      metaTitle: `Laravel Development Company | Laravel Development Services`,
      metaDescription: "As a top laravel development company USA, we possess extensive expertise in laravel and provide complete laravel development services to build custom apps.",
      ogImage: LaravelDevelopmentOgImage,
      twitterImage: LaravelDevelopmentOgImage
};

export const DjangoDevelopmentMeta = {
      metaTitle: `Django Software Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a trusted Django development company USA expert in providing complete Django development services & building highly scalable yet stylish web apps.",
      ogImage: DjangoDevelopmentOgImage,
      twitterImage: DjangoDevelopmentOgImage
};

export const MeanStackDevelopmentMeta = {
      metaTitle: `Top MEAN Stack Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits - A MEAN stack development company India, USA - help you craft powerful digital solutions that engage users, solve business pains & drive quick growth.",
      ogImage: MeanStackDevelopmentOgImage,
      twitterImage: MeanStackDevelopmentOgImage
};

export const MernStackDevelopmentMeta = {
      metaTitle: `Trusted MERN Stack Development Service Company - Peerbits`,
      metaDescription: "Peerbits is a leading MERN stack development company in India, USA trusted to develop feature-rich, interactive, robust, & scalable custom web apps.",
      ogImage: MernStackDevelopmentOgImage,
      twitterImage: MernStackDevelopmentOgImage
};



export const SymfonyDevelopmentMeta = {
      metaTitle: `Custom Symfony Development Services Company - Peerbits`,
      metaDescription: "Peerbits is a reliable Symfony development company in India offering cost-effective Symfony development services at an affordable rate to global clients.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PortugalStrategicPartnershipMeta = {
      metaTitle: `Schedule a Meeting with Our Portugal Technical Partners`,
      metaDescription: "Peerbits is now having its official physical presence in Portugal to help native businesses succeed. Meet our partners and discuss your business growth.",
      ogImage: PortugalStrategicPartnershipImage,
      twitterImage: PortugalStrategicPartnershipImage
};

export const OurClientsMeta = {
      metaTitle: `Our Esteemed Global Clients - Peerbits`,
      metaDescription: "Peerbits - Discover our esteemed global clients. A testament to our exceptional services, expertise, & successful partnerships across various industries.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FinancialSoftwareDevelopmentMeta = {
      metaTitle: `Financial Software Development | Peerbits`,
      metaDescription: "Do you want to build a secure fintech app? We offer extensive Fintech software development that improves security and brings transparency to your firms.",
      ogImage: FinancialSoftwareDevelopmentOgImage,
      twitterImage: FinancialSoftwareDevelopmentOgImage
};

export const LogisticsSoftwareDevelopmentMeta = {
      metaTitle: `Logistics and Transportation Software Development Services`,
      metaDescription: "We build custom logistics and transportation software including TMS development, delivery and logistics automation solutions & more for a seamless supply chain.",
      ogImage: LogisticsSoftwareDevelopmentOgImage,
      twitterImage: LogisticsSoftwareDevelopmentOgImage
};

export const HealthcareSoftwareDevelopmentMeta = {
      metaTitle: `Custom Healthcare Software Services & Development Company`,
      metaDescription: "We are a top healthcare software development company offering advanced healthcare software development services that blend tech & compliance for bthe est outcomes.",
      ogImage: HealthcareSoftwareDevelopmentOgImage,
      twitterImage: HealthcareSoftwareDevelopmentOgImage
};

export const DigitalTransformationMeta = {
      metaTitle: `Digital Transformation Services Company - Peerbits`,
      metaDescription: "Peerbits offers a digital transformation (DX) consulting company helping businesses with our services to reimagine their models and achieve competitive advantage.",
      ogImage: DigitalTransformationOgImage,
      twitterImage: DigitalTransformationOgImage
};

export const SaasDevelopmentCompanyMeta = {
      metaTitle: `SaaS Product Development Services Company - Peerbits`,
      metaDescription: "Peerbits - A Leading SaaS Development Company in India, USA. From startups to enterprises, we offer 100% specialized SaaS application development services.",
      ogImage: SaasDevelopmentCompanyOgImage,
      twitterImage: SaasDevelopmentCompanyOgImage
};

export const MvpDevelopmentCompanyMeta = {
      metaTitle: `Top MVP Mobile and Web App Development Company - Peerbits`,
      metaDescription: "Peerbits is a top MVP development company with 11 years of IT experience, offering tailored solutions for startups & enterprises. Launch your MVP in 2-14 days.",
      ogImage: MvpDevelopmentCompanyOgImage,
      twitterImage: MvpDevelopmentCompanyOgImage
};

export const SoftwareDevelopmentCompanyPortugalMeta = {
      metaTitle: `Software Development Service Company in Portugal - Peerbits`,
      metaDescription: "Peerbits, a leading web, mobile and software development company, delivers out of the box solutions to the clients in Portugal. Get a free no obligation quote.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ApacheKafkaMeta = {
      metaTitle: `Apache Kafka Service: Real-Time Data Streaming Solutions`,
      metaDescription: "Discover the power of Apache Kafka service for seamless real-time data streaming & processing. Learn how to unlock full potential of data with Apache Kafka today.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RedisMeta = {
      metaTitle: `Redis Services: Enhance Data Performance and Scalability`,
      metaDescription: "Unlock power of Redis with our services. Optimize data performance, scalability & reliability. Harness the potential of real-time data with our custom solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ElasticSearchMeta = {
      metaTitle: `Elasticsearch Services for Data Optimization and Analysis`,
      metaDescription: "Harness Elasticsearch's potential to organize, analyze, and visualize your data like never before. Optimize your data-driven decisions with us.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ApacheFlinkMeta = {
      metaTitle: `Empower Your Data Processing with Apache Flink Services`,
      metaDescription: "Discover top-tier Apache Flink services tailored to optimize data processing efficiency. Our experts at Peerbits deliver cutting-edge solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const DatadogMonitoringServicesMeta = {
      metaTitle: `DataDog Monitoring Consulting Company | DataDog Services`,
      metaDescription: "Explore DataDog's comprehensive suite of services to monitor, analyze, and optimize your infrastructure, applications, and logs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DockerandkubernetesMeta = {
      metaTitle: `Accelerate Development: Unleash Power of Docker & Kubernetes`,
      metaDescription: "Discover the agility of development with Docker and Kubernetes. Harness containerization and orchestration for seamless deployment, scalability, and efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RemotePatientMonitoringSolutionsMeta = {
      metaTitle: `Remote Patient Monitoring Solutions Company | Peerbits`,
      metaDescription: "Our remote patient monitoring solutions help doctors & patients. We are a leading RPM software development agency helping our clients with the best solutions.",
      ogImage: RemotePatientMonitoringSolutionsOgImage,
      twitterImage: RemotePatientMonitoringSolutionsOgImage
};
export const PatientEngagementSoftwareDevelopmentMeta = {
      metaTitle: `Patient engagement software solution development | Peerbits`,
      metaDescription: "Peerbtis develop custom patient engagement software apps for healthcare organizations to help them connect with patients remotely & provide effective treatment.",
      ogImage: PatientEngagementSoftwareDevelopmentOgImage,
      twitterImage: PatientEngagementSoftwareDevelopmentOgImage
};

export const DevopsConsultingServicesMeta = {
      metaTitle: `DevOps Implementation & Consulting Services | DevOps using AWS`,
      metaDescription: "Unsure where to start with DevOps? Begin now with our expert DevOps consultants offering customized analysis & strategies in our DevOps consulting services.",
      ogImage: DevopsConsultingServicesOgImage,
      twitterImage: DevopsConsultingServicesOgImage
};

export const DevopsCiCdServicesMeta = {
      metaTitle: `Automate DevOps CI/CD Services | DevOps CI/CD Consultants`,
      metaDescription: "Optimize your software development with our DevOps CI/CD services. Implement reliable automation and deployment through our custom DevOps CI/CD solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};

export const DevopsAutomationServicesMeta = {
      metaTitle: `DevOps Automation Services & Consulting Company`,
      metaDescription: "Automate repetitive tasks and streamline your workflow with our DevOps automation services for faster deployments, lower development costs & more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};

export const DevopsServicesMeta = {
      metaTitle: `Top DevOps Services Provider | DevOps Consulting Company`,
      metaDescription: "Automate tasks, optimize deployments, and build scalable software with our reliable DevOps services and solutions for businesses of all sizes.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};

export const DevopsMicroServicesMeta = {
      metaTitle: `DevOps Microservices Consultant | Container Orchestration`,
      metaDescription: "Give your systems a modernized, resilient & scalable solution with our DevOps Microservices expertise. Utilize our DevOps container services for creating future-ready applications.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};

export const DevopsServerlessArchitectureMeta = {
      metaTitle: `Design Serverless Architecture | DevOps Serverless Design`,
      metaDescription: "Design scalable DevOps serverless architect which helps to deployments easy & optimize costs with our expert DevOps serverless architecture services.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};

export const CloudServicesAndSolutionsMeta = {
      metaTitle: `Cloud Services and Solutions|Future-proofed Cloud Solutions`,
      metaDescription: "Looking for reliable cloud services and solutions for scalable business upgrades? Peerbits offers a variety of cloud solutions across enterprises.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const CloudNativeDevelopmentServicesMeta = {
      metaTitle: `Cloud Native Development Services`,
      metaDescription: "Leave outdated practices & build cloud-native applications with us. Revolutionize with our cloud-native development services for faster & agile builds.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const CloudConsultingServicesMeta = {
      metaTitle: `Cloud Consulting Services | Cloud Consultant`,
      metaDescription: "Streamline your operations with our cloud consulting services. Get expert planning, seamless migration & resilient security consulting with certified cloud experts.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const LlmAServicePageMeta = {
      metaTitle: `LLM development services | LLM as a service`,
      metaDescription: "Get top LLM development services that offer end-to-end support. With LLM as a service, we guide you through every stage of your LLM product development needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const AiopsmlopsservicesPageMeta = {
      metaTitle: `AIOps as a Service | MLOps as a Service`,
      metaDescription: "Maximize AI performance and IT efficiency with our AIOps and MLOps services. From automated monitoring to secure model scaling, we drive smarter, faster operations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const AiintegrationservicesMeta = {
      metaTitle: `AI Integration Services | AI Data Integration`,
      metaDescription: "Give your business a future-ready upgrade with expert AI integration services. Automate, optimize & boost workflows with generative AI integrations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const PromptchainingaiservicesMeta = {
      metaTitle: `Prompt Chaining AI Services | Prompt Structure Chaining​`,
      metaDescription: "Transform workflows & automate complex operations with our prompt chaining AI services. Our prompt chaining solutions deliver reliable structure based on your needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const AirecruitmentsolutionsMeta = {
      metaTitle: `AI Recruitment Soutions | AI Recruiting Tool`,
      metaDescription: "Discover AI recruitment solutions that automate hiring workflows. You get resume parser, resume score checker AI, & bias-free selection with this AI recruiting tool.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const AichatbotschedulingassistantsolutionsMeta = {
      metaTitle: `AI Chatbot for Bookings | AI scheduling assistant`,
      metaDescription: "Upgrade your booking system with AI automation. Our AI scheduling assistant solutions manage appointments handle payments, & provide instant responses 24/7.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const aidevelopmentservicesMeta = {
      metaTitle: `AI Development Services Landing Page- Peerbits`,
      metaDescription: "",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const awscloudcomputingservicesMeta = {
      metaTitle: `AWS Cloud Computing Services-Landing Page`,
      metaDescription: "",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const MachinelearningdevelopmentservicesMeta = {
      metaTitle: `Machine Learning Development Services | Machine Learning Company`,
      metaDescription: "Need expert Machine Learning services from a top ML development company? Our top-tier consultants apply AI/ML to solve even the most complex enterprise challenges.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const ComputervisionservicesandsolutionsMeta = {
      metaTitle: `Computer Vision Services and Solutions | Computer Vision AI`,
      metaDescription: "Automate with AI-powered computer vision services and solutions. From automation to analytics, we offer intelligent computer vision AI for image & video processing.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const CloudMigrationServicesMeta = {
      metaTitle: `Cloud Migration Services and Strategy`,
      metaDescription: "Begin your cloud migration journey with us. Our expert cloud migration services make your shift to the cloud effortless with visible & faster business results.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const CloudManagedServicesMeta = {
      metaTitle: `Cloud Managed Services-Cloud Data Management | Peerbits`,
      metaDescription: "Want to achieve budget-friendly cloud with continuous support, monitoring & audit? Try us, we offer highly reliable cloud managed services for all businesses.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};

export const GuideToHiringATeam = {
      metaTitle: `A Comprehensive Guide to Hiring a Dedicated Developers Team`,
      metaDescription: "Building a great team starts with hiring the right people. Our guide will help you navigate the hiring process and find the best resources for your business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhyOutsourceToIndia = {
      metaTitle: `Why Outsource IT Services to India | Outsourcing Benefits`,
      metaDescription: "Outsource to India with Peerbits and get access to high-quality, cost-effective software development services and a large talent pool of IT professionals.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhyOutsource = {
      metaTitle: `Why Outsource Your Next Project - Peerbits`,
      metaDescription: "Outsource your project to upscale development capabilities. You can concentrate on your core business while outsourcing certain tasks to a third party.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhyOutsourceToPeerbits = {
      metaTitle: `Hire Dedicated Team, Offshore Development Team in India`,
      metaDescription: "Save time and money by hiring dedicated team in India. Hire dedicated offshore development team for your next project to avail high quality services.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwsmanagedservicesPageMeta = {
      metaTitle: `AWS Managed Cloud Services| Managed AWS Services`,
      metaDescription: "Want to achieve a budget-friendly cloud with continuous support, monitoring & audit? Try us, we offer highly reliable AWS managed services for all businesses.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AwscloudarchitectureservicesMeta = {
      metaTitle: `AWS Cloud Architecture Services | Peerbits`,
      metaDescription: "Future-proof your cloud infrastructure with scalable, agile, and secure AWS architecture, designed by our certified AWS solution architects in AWS cloud architecture services.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwscloudmigrationservicesPageMeta = {
      metaTitle: `AWS Cloud Migration Services| AWS Migration Strategies`,
      metaDescription: "Transform your business by migrating from any workload, whether on-premise or other public clouds with our end-to-end AWS cloud migration services with ease.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwscloudsecurityservicesMeta = {
      metaTitle: `AWS Cloud Security Services | Cloud Security Compliance`,
      metaDescription: "Protect your cloud environment with custom AWS cloud security services. Achieve compliance, detect threats, and safeguard sensitive data effortlessly with Peerbits.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AidevelopmentservicesMeta = {
      metaTitle: `AI Development Services | AI Development Company`,
      metaDescription: "Make your business future-ready with our AI development services. From custom AI tech to machine learning, we build smarter systems that fit your specific needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AichatbotdevelopmentservicesMeta = {
      metaTitle: `AI Chatbot Development Services | AI Chatbot Solutions`,
      metaDescription: "Improve customer interactions with our AI chatbot development services. Deliver scalable & intelligent AI chatbot solutions with the best AI chatbots.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AiconsultingservicesMeta = {
      metaTitle: `AI Consulting Services | Artificial Intelligence Consulting Firm`,
      metaDescription: "Maximize your business potential with our AI consulting services. From AI strategy to implementation, we help you achieve AI-driven success.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AiagentdevelopmentMeta = {
      metaTitle: `AI Agent Development | AI Agent Builders`,
      metaDescription: "Discover our AI agent development services powered by our certified AI experts who build intelligent, adaptive agents that enhance automation & drive business growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AihrmssolutionsMeta = {
      metaTitle: `AI HRMS Solution | HR Chatbot`,
      metaDescription: "Speed up office workflows with an AI HR Chatbot. From recruitment to employee management, our AI HRMS solution makes processes smarter, faster, and more efficient.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwscloudcomputingprocessMeta = {
      metaTitle: `AWS Cloud Computing Process & Certified Expertise`,
      metaDescription: "Explore our streamlined AWS cloud computing process, guided by certified experts. From planning to secure management get custom cloud solutions at cost-friendly rates.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const CloudassessmentservicesPageMeta = {
      metaTitle: `Cloud Assessment Services |  Cloud Performance Testing`,
      metaDescription: "Optimize your cloud strategy with our cloud assessment services evaluating infrastructure, improving performance & offering cost-effective custom cloud solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwscicdpipelineservicesPageMeta = {
      metaTitle: `AWS CI/CD Pipeline Services | CI/CD Automation Services`,
      metaDescription: "Streamline your software development with our AWS CI/CD pipeline services. Our AWS experts automate build, test, & deploy processes for faster & efficient delivery.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwsserverlessservicesPageMeta = {
      metaTitle: `Serverless Development Solutions | AWS Serverless Services`,
      metaDescription: "Transform your cloud journey with expert AWS Serverless Architecture Services. Achieve scalability, reduced costs & enhanced app performance custom to your needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AwsmicroservicesarchitectureconsultingservicesPageMeta = {
      metaTitle: `AWS Microservices Architecture Consulting Services`,
      metaDescription: "Unlock the power of agility with our AWS microservices architecture consulting services. Design, build & deploy scalable custom infrastructures with ease.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const MonitoringandservermaintenanceservicesPageMeta = {
      metaTitle: `AWS Monitoring & Server Maintenance Services`,
      metaDescription: "Achieve peak performance with our AWS monitoring and server maintenance services offering 24/7 monitoring, automated backups & more for secure cloud infrastructure.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const CloudauditoptimisationandperformanceservicesPageMeta = {
      metaTitle: `Cloud Audit, Optimization & Performance Services`,
      metaDescription: "Boost your cloud performance with custom AWS cloud audit and optimization services. Identify inefficiencies, reduce costs, and scale seamlessly.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HiremobileappdevelopersMeta = {
      metaTitle: `Hire Mobile App Developers | Remote App Developer For Hire`,
      metaDescription: "Hire mobile app developers from India to create iOS, Android, and cross-platform apps. Get a 14-day risk-free trial on mobile app developers with affordable pricing.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const HiresoftwaredevelopersMeta = {
      metaTitle: `Hire Software Developers | Dedicated Software Developers for Hire`,
      metaDescription: "Hire dedicated software developers for front-end, back-end, and full-stack solutions. Enjoy 14-day risk-free trial with flexible hiring models for quality-rich software.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const HirewebdevelopersMeta = {
      metaTitle: `Hire Web Developers | Dedicated Web Developers for Hire`,
      metaDescription: "Hire web developers to build a variety of web development solutions with ease. Get fast onboarding, quality codes, global time-zone availability & 14-day trial now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const RagAsAServicePageMeta = {
      metaTitle: `Best AI Retrieval Augmented Generation​| RAG as a Service`,
      metaDescription: "Upgrade your AI from our best AI Retrieval Augmented Generation (RAG) services. Our RAG solutions offer context-rich, real-time responses for top efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const GenerativeAIDevelopmentServicesPageMeta = {
      metaTitle: `Generative AI Development Services | Generative AI solutions`,
      metaDescription: "Our Generative AI development services help businesses innovate with custom AI solutions, backed by expert consulting and industry-leading development.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AianalyticsolutionMeta = {
      metaTitle: `AI Business Analytics | AI Analytics Solutions`,
      metaDescription: "Empower your business with intelligent AI business insights. Our AI analytics solutions automate data analytics with predictive models to accelerate productivity.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ItstaffaugmentationcompanyMeta = {
      metaTitle: `IT Staff Augmentation Company | Peerbits`,
      metaDescription: "Boost your development with top IT staff augmentation services. Developers from our IT staff augmentation company offer on-time work delivery & integrate smoothly.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const NearshoresoftwaredevelopmentMeta = {
      metaTitle: `Nearshore Software Development Company & Services-Peerbits`,
      metaDescription: "Partner with us— a nearshore software development company offering time zone-aligned, cost-effective nearshore development services customized to your business goals.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const OffshoresoftwaredevelopmentMeta = {
      metaTitle: `Offshore Software Development Company & Services-Peerbits`,
      metaDescription: "Boost your product roadmap with an offshore software development company offering full-stack expertise & end-to-end offshore development services.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const PartnerwithpbcollabrationMeta = {
      metaTitle: `Custom Engagement Models for Tech Needs- Peerbits`,
      metaDescription: "Explore diverse ways to collaborate with us. Whether it’s project-based, white-label, or co-branded partnerships, get flexible development execution seamlessly.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const AiSoftwareDevelopmentCompanyPageMeta = {
      metaTitle: `AI Software Development Company & Services`,
      metaDescription: "Build artificially intelligent systems that are custom to your vision. Our AI software development company focuses on quality AI software solutions that grow with your business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const HireAiDevelopersPageMeta = {
      metaTitle: `Hire Artificial Intelligence Developers & Engineers`,
      metaDescription: "Looking to build smarter AI solutions? Hire AI developers & engineers India through Peerbits for flexible models, rapid onboarding, and dependable results.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const AimobileappdevelopmentMeta = {
      metaTitle: `AI Mobile App Development Company & Services`,
      metaDescription: "Power your vision with AI-powered mobile apps. As a top AI mobile app development company, we deliver scalable and secure solutions custom to your industry needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const LegacyApplicationModernizationServicesMeta = {
      metaTitle: `Legacy Software Modernization Services -Peerbits`,
      metaDescription: "Outdated software holding you back? Our legacy software modernization services help you upgrade fast, secure, and reduce costs, without affecting operations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
export const SoftwareIntegrationServicesMeta = {
      metaTitle: `Software Integration Services | Software Integration Company`,
      metaDescription: "Get scalable software integration services for custom apps, cloud tools, APIs, and legacy systems. We simplify system communication and automation.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage,
};
// export const PatientRegistrySoftwareDevelopmentMeta = {
//       metaTitle: `Seamless Patient Registry Software Development Services`,
//       metaDescription: "Go beyond basic registries! At Peerbits, We craft secure & custom patient registry software. Build powerful,HIPAA-compliant solutions for research & quality improvement.",
//       ogImage: PatientRegistrySoftwareDevelopmentOgImage,
//       twitterImage: PatientRegistrySoftwareDevelopmentOgImage
// };
// export const TelemedicineAppDevelopmentMeta = {
//       metaTitle: `Best Healthcare with our Telemedicine App Development`,
//       metaDescription: "Peerbits is dedicatedly working for healthcare software development since last 14+ years. We help businesses to build scalable world-class softwares",
//       ogImage: TelemedicineAppDevelopmentOgImage,
//       twitterImage: TelemedicineAppDevelopmentOgImage
// };
// export const HealthcareIotSolutionsMeta = {
//       metaTitle: `Healthcare IoT Solutions for Businesses`,
//       metaDescription: "The integration of healthcare and IoT has been a strength of Peerbits since long. We are climbing peaks with our 14+ years healthcare IoT experience",
//       ogImage: HealthcareIotSolutionsOgImage,
//       twitterImage: HealthcareIotSolutionsOgImage
// };
// export const MhealthappMeta = {
//       metaTitle: `Expert mHealth App Development Services by Peerbits`,
//       metaDescription: "Experience our easy-to-use mHealth app development. From remote monitoring to health tracking, our solutions are designed for simplicity and security. Connect to experience the healthcare transformation.",
//       ogImage: MhealthappOgImage,
//       twitterImage: MhealthappOgImage
// };
// export const EwalletappdevelopmentMeta = {
//       metaTitle: `Develop your E-Wallet App: Seamless Development Solutions`,
//       metaDescription: "Smoothen your digital transactions with Peerbits' easy-to-use e-wallet app development services. Our secure and user-friendly solutions are designed to make financial management easy.",
//       ogImage: EwalletappdevelopmentOgImage,
//       twitterImage: EwalletappdevelopmentOgImage
// };
// export const MobilebankingMeta = {
//       metaTitle: `Create Mobile Banking App with Our Expert Development Services`,
//       metaDescription: "Experience banking on your fingertips. Peerbits' mobile banking app development solutions provide secure, user-friendly options customized for your bank. Explore the convenience.",
//       ogImage: MobilebankingOgImage,
//       twitterImage: MobilebankingOgImage
// };
// export const MerchantPaymentServicesMeta = {
//       metaTitle: `Get Secured Merchant Payment Services with Peerbits`,
//       metaDescription: "Want to power up your business with robust merchant payment services? Build hassle-free payment experience for client satisfaction and loyalty. Let’s discuss!",
//       ogImage: MerchantPaymentServicesOgImage,
//       twitterImage: MerchantPaymentServicesOgImage
// };

// export const CrossBorderRemittanceSoftwareDevelopmentMeta = {
//       metaTitle: `Transform Your Remittance Process with Adept Cross-Border Remittance Software Development`,
//       metaDescription: "Experience smooth international fund transfers with Peerbits' cross-border remittance software development services. Optimize security and compliance today.",
//       ogImage: CrossBorderRemittanceSoftwareDevelopmentOgImage,
//       twitterImage: CrossBorderRemittanceSoftwareDevelopmentOgImage
// };

// export const FleetManagementMeta = {
//       metaTitle: `Fleet Management Software Development | Peerbits`,
//       metaDescription: "Increase your efficiency with advanced fleet management software. Mitigate risks, check driver’s behavior, schedule maintenance in a few tabs. Let’s discuss.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage
// };
// export const RealTimeAssetTrackingMeta = {
//       metaTitle: `Integrate Real-Time Asset-Tracking With Peerbits`,
//       metaDescription: "Are you fed up with replacing your assets due to poor maintenance? Integrate our asset-tracking software with your ERP system for better optimization of assets.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage
// };
// export const WarehouseManagementSystemMeta = {
//       metaTitle: `Warehouse Management Software | Peerbits`,
//       metaDescription: "Do you fail to find storage space in your warehouse? Our warehouse management software comes with AI-powered optimization to help you analyze ample storage.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage
// };
// export const LogisticsSoftwareDevelopment1Meta = {
//       metaTitle: `Custom Logistic Software Development Company | Peerbits`,
//       metaDescription: "Want to streamline your logistics operations? Invest in transportation and logistics software development that optimizes operations, routes, and overheads.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage,
// };
// export const LogisticsAndTransportationMeta = {
//       metaTitle: `Logistics And Transportation Software | Peerbits`,
//       metaDescription: "Do you experience supply chain disruptions? Then you must invest in Logistics and transportation software management. Connect now to unlock sustainable software.",
//       ogImage: SocialDefaultImage,
//       twitterImage: SocialDefaultImage,
// };

